var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8333C12.5001 10.3955 12.6151 9.96541 12.8336 9.58602C13.0521 9.20662 13.3664 8.89126 13.745 8.67149C14.1237 8.45171 14.5534 8.33523 14.9912 8.33369C15.429 8.33216 15.8596 8.44563 16.2398 8.66274C16.62 8.87986 16.9365 9.19301 17.1576 9.57086C17.3788 9.94871 17.4968 10.378 17.4999 10.8158C17.5031 11.2536 17.3912 11.6846 17.1754 12.0655C16.9597 12.4465 16.6477 12.7642 16.2707 12.9867C15.6373 13.3613 15 13.9307 15 14.6667V16.3333",
    stroke: "#9F9F9E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.6667C15.7364 21.6667 16.3334 21.0697 16.3334 20.3333C16.3334 19.597 15.7364 19 15 19C14.2636 19 13.6667 19.597 13.6667 20.3333C13.6667 21.0697 14.2636 21.6667 15 21.6667Z",
    fill: "#9F9F9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33332 3.45067C10.3594 2.27854 12.6593 1.66307 15 1.66667C22.364 1.66667 28.3333 7.63601 28.3333 15C28.3333 22.364 22.364 28.3333 15 28.3333C7.63599 28.3333 1.66666 22.364 1.66666 15C1.66666 12.572 2.31599 10.2933 3.45066 8.33334",
    stroke: "#9F9F9E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.b193eeeb6a2c9f6839e13b813ca11291.svg";
export { ForwardRef as ReactComponent };